// extracted by mini-css-extract-plugin
export var body = "_mo-0";
export var sectionHeader = "_mo-4";
export var shortcutColumns = "_mo-2";
export var shortcutList = "_mo-1";
export var shortcutSection = "_mo-3";